import { render, staticRenderFns } from "./inputData.vue?vue&type=template&id=2f8f3c3f&scoped=true"
import script from "./inputData.vue?vue&type=script&lang=js"
export * from "./inputData.vue?vue&type=script&lang=js"
import style0 from "./inputData.vue?vue&type=style&index=0&id=2f8f3c3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f3c3f",
  null
  
)

export default component.exports